export const getCurso = (curso, formacion) => {
  const cursoActual = String(curso || '') ? `${curso}º` : ''
  if (!formacion) return '[Desconocido]'
  return [cursoActual, formacion].join(' ')
}
